'use client';
import { ProjectTypes } from '../styles-utils';

export const getProjectType = (): ProjectTypes | null => {
  const projectName =
    process.env['NEXT_PUBLIC_APP_PROJECT_NAME'] ||
    process.env['APP_PROJECT_NAME'];

  switch (projectName) {
    case ProjectTypes.SSO:
      return ProjectTypes.SSO;
    case ProjectTypes.Membership:
      return ProjectTypes.Membership;
    case ProjectTypes.PlayerPortals:
      return ProjectTypes.PlayerPortals;
    default:
      return ProjectTypes.SSO;
  }
};
